import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import StarField from './components/StarField';
import Footer from './components/Footer';
import Home from './pages/Home';
import Priser from './pages/Priser';
import Faciliteter from './pages/Faciliteter';
import OmOs from './pages/OmOs';
import Login from './pages/Login';
import BlivMedlem from './pages/BlivMedlem';
import Events from './pages/Events';
import Handelsbetingelser from './pages/Handelsbetingelser';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <StarField />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/priser" element={<Priser />} />
        <Route path="/faciliteter" element={<Faciliteter />} />
        <Route path="/om-os" element={<OmOs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/login" element={<Login />} />
        <Route path="/bliv-medlem" element={<BlivMedlem />} />
        <Route path="/handelsbetingelser" element={<Handelsbetingelser />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
